import { Component, ViewContainerRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ErrorService } from '../../services/error.service';
import { SnackbarService } from '../../services/snackbar.service';
import { UserService } from '../../services/user.service';

@Component({
	selector: 'app-password-reset-modal',
	templateUrl: './password-reset-modal.html'
})
export class PasswordResetModalComponent {
	public form: UntypedFormGroup;

	constructor(private _errorService: ErrorService,
				private _vcRef: ViewContainerRef,
				private _userService: UserService,
				public dialogRef: MatDialogRef<PasswordResetModalComponent>,
				private _fb: UntypedFormBuilder,
				private _snackbarService: SnackbarService) {
		this.form = this._fb.group({
			emailAddress: ['', [Validators.required, Validators.email]]
		})

	}

	close(response) {
		this.dialogRef.close(response);
	}

	submit(form) {
		if (form.valid) {
			this._userService.resetPassword(form?.value?.emailAddress).subscribe(() => {
				this.close(true);
			}, error => {
				this._errorService.error(error, 'resetPassword failed', 'modal');
			});
		} else {
			this._snackbarService.openSnackBar('Please fill out all required fields.', 'Close', 3000);
		}
	}
}
